BaseStep    = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep")
FieldsUploadHandler = App.loadClass("grower::handlers/fields/Fields_Upload_Handler")


class exports.UploadStart extends BaseStep
    afterSet: () ->

        # Okay, so this is terrible and bad and stupid.
        # Right now i dont' really have to to fix this up proper, so it's just hijacking the old
        # upload process and using it.
        sub = @parent.handler.createSubHandler FieldsUploadHandler
        if sub
            sub.init()
            sub.loadLayout()
